module.exports = __webpack_public_path__ + "static/media/zxs_ys.5e3f582f.png";